<template>
  <div id="app">
    <PixsoNav />
    <router-view />
    <ToUp />
    <Footer v-show="!isMobile" />
    <FooterM v-show="isMobile" />
  </div>
</template>

<script setup>
// 添加h-c进入时的动画效果
import { useScrollAnimation } from '@/js/useScrollAnimation.js'
import { useGlobalTextReveal } from '@/js/useGlobalTextReveal.js'
useScrollAnimation()
useGlobalTextReveal()
// 添加h-c进入时的动画效果

import PixsoNav from '@/components/pixso/PixsoNav.vue'
import ToUp from '@/components/ToUp.vue'
import Footer from './components/Footer.vue';
import FooterM from './components/FooterM.vue';


// 根据宽度判断手机端
import { useScreenWidth } from '@/js/useScreenWidth'
const isMobile = useScreenWidth()
// 根据宽度判断手机端

</script>
